import { DefaultLegendContentProps, LegendPayload } from 'recharts'
import { useTranslation } from 'react-i18next'

const isValid = (legendPayload: LegendPayload) => {
  if (!legendPayload) return false
  if (!legendPayload.value) return false
  if (!legendPayload.color) return false
  return true
}
const CumulativeChartLegend = ({ payload }: DefaultLegendContentProps) => {
  const { t } = useTranslation()

  const realized: LegendPayload = payload[1]
  const forecast: LegendPayload = payload[0]
  const trajectory: LegendPayload = payload[2]

  return (
    <div className="vp-caption mg-cumulative-chart-legend">
      {isValid(realized) && (
        <div className={'legend-line'}>
          <div id="plain-line" style={{ background: realized.color, width: '13px', height: '3px' }}></div>
          <div className={'legend-text'}>{t('general.cumulative_charts.realized_gmv')}</div>
        </div>
      )}
      {isValid(forecast) && (
        <div className={'legend-line'}>
          <div id="dashed-line" style={{ width: '13px', borderBottom: '2px dashed ' + forecast.color }}></div>
          <div className={'legend-text'}>{t('general.cumulative_charts.probable_gmv')}</div>
        </div>
      )}
      {isValid(trajectory) && (
        <div className={'legend-line'}>
          <div
            id="square"
            style={{ background: trajectory.color, width: '13px', height: '13px', borderRadius: '2px' }}
          ></div>
          <div className={'legend-text'}>{t('general.cumulative_charts.trajectory')}</div>
        </div>
      )}
    </div>
  )
}
export default CumulativeChartLegend
